import React from 'react';
import { Modal, ModalProps } from 'react-bootstrap';
import { useMutation } from '@tanstack/react-query';
import { Representative } from '../../types';
import { ControlledAlertModal } from '../../../common/ControlledModal';
import { resendContractSigningEmail } from '../backofficeServices';
import { Alert } from '../../../common/Alert';

interface ResendEmailConfirmationProps extends ModalProps {
  data: Representative
}

export function ResendEmailConfirmationModal({ show, onHide, data }: ResendEmailConfirmationProps) {
  if (!data) return null;
  const description = `¿Está seguro/a de que desea reenviar el correo para firmar a ${data.representative_email}?`;

  const { mutate, isLoading, isError } = useMutation({
    mutationFn: () => resendContractSigningEmail({ representativeId: data.id }),
    onSuccess: async () => {
      onHide?.();
    },
  });

  return (
    <ControlledAlertModal
      show={show}
      onHide={onHide}
      title="Reenviar correo de confirmación"
      description={description}
      closeButton
      centered
    >
      {isError && (
        <Alert variant="danger" title="Error">
          Algo salió mal al reenviar el correo de confirmación. Por favor, intenta nuevamente.
        </Alert>
      )}
      <Modal.Footer className="d-flex align-items-end gap-2">
        <ControlledAlertModal.Actions
          handleClose={onHide || (() => {})}
          onConfirm={() => mutate()}
          isPending={isLoading}
        />
      </Modal.Footer>
    </ControlledAlertModal>
  );
}
